/* eslint-disable */
import {
  InvoiceViewDetails,
  InvoiceHistory,
  InvoiceListResponse,
  InvoiceEditDetails,
  InvoiceEmployeeDetails,
} from 'src/interfaces';
import http from './http';
import axios, { AxiosError } from 'axios';

class InvoiceService {
  static addInvoice(formData: FormData) {
    return http
      .post(`/invoice/create`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static updateInvoice(id: string, formData: FormData) {
    return http
      .patch(`invoice/update/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getInvoiceDetails(params: any): Promise<InvoiceViewDetails> {
    return http.get(`/invoice/detail/${params.invoiceId}`).then(resp => resp.data);
  }

  static getInvoiceEditDetails(params: any): Promise<InvoiceEditDetails> {
    return http.get(`/invoice/detail/${params.invoiceId}`).then(resp => resp.data);
  }

  static getInvoiceHistory(params: any): Promise<InvoiceHistory[]> {
    return http.get(`/invoice/history/${params.invoiceId}`).then(resp => resp.data);
  }

  static approveInvocie(invoiceId: string, invoice: any) {
    return http
      .patch(`/invoice/approve/${invoiceId}`, invoice, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static rejectInvocie(invoiceId: string, invocie: any) {
    return http
      .patch(`/invoice/reject/${invoiceId}`, invocie, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getInvoiceList(params: any): Promise<any> {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, String(value));
      }
    });

    return http.get(`invoice/my-invoices?${searchParams.toString()}`).then(resp => resp.data);
  }

  static deleteInvocie(invoiceId: string, invocie: any) {
    return http
      .patch(`/admin/invoice/delete/${invoiceId}`, invocie, {})
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getAssignments() {
    return http
      .get(`/assignment/fetch`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getAssignmentsPersonalNumber() {
    return http
      .get(`/assignment/fetch/personnelNumber`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          return err;
        }
      });
  }

  static getEmployee(): Promise<InvoiceEmployeeDetails> {
    return http.get(`/invoice/employee-detail`).then(resp => resp.data);
  }

  static searchClients(params: { clientSearch: string; limit?: number }) {
    let query = `clientSearch=${params.clientSearch}`;

    if (params.limit) {
      query += `&limit=${params.limit}`;
    }

    return http
      .get(`admin/assignment/clients/search?${query}`)
      .then(resp => resp.data)
      .catch((err: Error | AxiosError) => {
        if (axios.isAxiosError(err)) {
          throw new Error(err.response?.data?.message);
        } else {
          throw err;
        }
      });
  }
}

export default InvoiceService;
